<template>
    <div class=" my">
        <nav-bar title="我的车辆"
                 left-text="返回"
                 left-arrow
                 @click-left="onClickLeft" class="my-nav" />
        <div style="height: 3rem"></div>
        <div style="margin: 1rem">
            <ant-form validate-first @submit="onSubmit" >
                <ant-field label="车牌号：" v-model="form.vehicleName" required
                           :rules="[{ required: true , message: '请填写车牌号' }]"
                           placeholder="请输入内容"/>
                <ant-field label="联系方式："
                           v-model="form.phone"
                           required type="tel"
                           placeholder="请输入联系方式"
                           :rules="[{ required: true, message: '请填写手机号' }]"/>
                <ant-field label="剩余座位："
                           v-model="form.seatNumber"
                           required type="number"
                           placeholder="请输入剩余座位"
                           :rules="[{ required: true, message: '请填写剩余座位' }]"/>
                <ant-field label="出发地点："
                           v-model="form.departure"
                           placeholder="请输入出发地点"
                           :rules="[{ required: true, message: '请填写出发地点' }]"/>
                <ant-field label="备注："
                           v-model="form.remark"
                           rows="2"
                           autosize
                           type="textarea"
                           maxlength="50"
                           placeholder="请输入内容"
                           show-word-limit/>
                <div style="margin: 16px;">
                    <ant-button round block type="danger" native-type="submit">
                        保存提交
                    </ant-button>
                </div>
            </ant-form>
        </div>
<!--        <picker-->
<!--                title="请选择活动类型"-->
<!--                v-show="showType"-->
<!--                show-toolbar-->
<!--                :columns="columns"-->
<!--                @confirm="onConfirm"-->
<!--                @cancel="onCancel"-->
<!--        />-->

    </div>
</template>

<script>
    import service from "../../api/service";
    import {
        Cell, CellGroup, NavBar, Divider,
        Button, Form, Field, DatetimePicker,
        Popup, Toast, Collapse, CollapseItem,
        Col, Row, Picker
    } from 'vant'

    export default {
        name: "myCar",
        components: {
            Cell, CellGroup,
            NavBar, Divider,
            AntButton: Button,
            AntForm: Form,
            AntField: Field, DatetimePicker, Popup,
            Collapse, CollapseItem, AntCol: Col, AntRow: Row,Picker
        },
        data() {
            return {
                form: {
                    id: '',
                    vehicleName: '',
                    phone: '',
                    departure: '',
                    seatNumber: 4,
                    remark: '',
                },
                showType:false,
                columns: ['地点一', '地点二', '地点三', '地点四', '地点五'],
            }
        },
        mounted() {
            this.init()
        },
        methods: {
            init() {
                service.get('/api/activity-creation-approval/myVehicleInformation', {
                    openid: sessionStorage.getItem("openid")
                }).then(res => {
                    if (res.status === 200 && res.data.length > 0) {
                        this.form = res.data[0]
                    }
                })
            },
            // onCancel() {
            //     this.showType = false
            // },
            // onConfirm(value, index) {
            //     this.showType = false
            //     this.form[0].startingPoint = value;
            // },
            // setMotionGroup() {
            //     this.showType = true
            // },
            //返回
            onClickLeft() {
                this.$router.push({path: '/personalCenter'})
            },
            //分享车位
            onSubmit() {
                let form = {...this.form}
                form.activityName = sessionStorage.getItem("activityName")
                form.openid = sessionStorage.getItem("openid")
                service.post('/api/activity-creation-approval/insertMyVehicle', form).then(res => {
                    if (res.status === 200) {
                        Toast.success("提交成功")
                        this.init()
                    } else {
                        Toast.fail("提交失败")
                    }
                })
            },
        }
    }
</script>

<style scoped>
    .my {
        background-color: #f7f8fa;
        min-height: 100vh;
    }
</style>